import { AfterViewInit, ContentChild, Directive, ElementRef, OnDestroy } from '@angular/core';
import { Subject, from, fromEvent, takeUntil } from 'rxjs';

@Directive({
  selector: '[hostThousandsSeparator]',
})
export class ThousandsSeparatorDirective implements AfterViewInit, OnDestroy {
  @ContentChild('input') input: ElementRef;
  @ContentChild('sepTpl') sepTpl: ElementRef;

  destory$ = new Subject<void>();

  constructor(private eleRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.input.nativeElement.style.color = '#fff';
    this.sepTpl.nativeElement.style.display = 'block';

    this.subscribeInputEvents();
  }

  private subscribeInputEvents() {
    const input = this.input.nativeElement;
    const sepTpl = this.sepTpl.nativeElement;

    fromEvent(input, 'focus')
      .pipe(takeUntil(this.destory$))
      .subscribe(() => {
        input.style.color = '#34383c';
        sepTpl.style.display = 'none';
      });

    fromEvent(input, 'blur')
      .pipe(takeUntil(this.destory$))
      .subscribe(() => {
        input.style.color = '#fff';
        sepTpl.style.display = 'block';
      });
  }

  ngOnDestroy(): void {
    this.destory$.next();
    this.destory$.complete();
  }
}
